"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactHookForm = require("react-hook-form");

var _material = require("@mui/material");

var _ui = require("@alycecom/ui");

var _reactRedux = require("react-redux");

var _services = require("@alycecom/services");

var _query = require("@reduxjs/toolkit/query");

var _moment = _interopRequireDefault(require("moment"));

var _hooks = require("../../../../../CampaignSettings/hooks");

var _messaging = require("../../constants/messaging.types");

var _SendAsPreview = _interopRequireDefault(require("../SendAsPreview"));

var _PlaceholdersTextField = _interopRequireDefault(require("../../../../../Shared/Messaging/Placeholders/components/PlaceholdersTextField"));

var _messaging2 = require("../../constants/messaging.helpers");

var _commonData = require("../../../../../Shared/store/commonData/commonData.selector");

var _messaging3 = require("../../constants/messaging.schema");

var _providers = require("../../../../providers");

var _features = require("../../../../../Shared/store/features");

var styles = {
  templateHelperBox: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  templateHelperLimit: {
    marginTop: function marginTop(_ref) {
      var spacing = _ref.spacing;
      return spacing(1);
    }
  }
};
var templateQueryParams = {
  includeDeleted: true
};

var MessageDataController = function MessageDataController(_ref2) {
  var _campaign$team, _batch$messaging, _batch$messaging3;

  var trigger = _ref2.trigger,
      control = _ref2.control,
      campaign = _ref2.campaign,
      isMessagingPending = _ref2.isMessagingPending,
      isGiftsCreatePending = _ref2.isGiftsCreatePending;
  var teamId = campaign === null || campaign === void 0 ? void 0 : (_campaign$team = campaign.team) === null || _campaign$team === void 0 ? void 0 : _campaign$team.id;
  var hasManageProspectingCampaignTemplate = (0, _reactRedux.useSelector)(_features.Features.selectors.hasFeatureFlag(_features.Features.FLAGS.MANAGE_PROSPECTING_CAMPAIGN_TEMPLATE));
  var bodyCharsLimit = (0, _reactRedux.useSelector)(_commonData.getEmailCharLimit);

  var _useGiftingFlowContex = (0, _providers.useGiftingFlowContext)(),
      batchId = _useGiftingFlowContex.batchId;

  var _useGetProspectingBat = (0, _services.useGetProspectingBatchByIdQuery)(batchId ? {
    batchId
  } : _query.skipToken),
      batch = _useGetProspectingBat.data;

  var sendAsPersons = batch === null || batch === void 0 ? void 0 : (_batch$messaging = batch.messaging) === null || _batch$messaging === void 0 ? void 0 : _batch$messaging.sendAsPersons;
  var subjectFieldName = "".concat(_messaging.MessagingDataFields.Message, ".").concat(_messaging.MessageFields.MessageSubject);
  var messageFieldName = "".concat(_messaging.MessagingDataFields.Message, ".").concat(_messaging.MessageFields.MessageBody);
  var templateIdFieldName = "".concat(_messaging.MessagingDataFields.Message, ".").concat(_messaging.MessageFields.TemplateId);

  var _useController = (0, _reactHookForm.useController)({
    control,
    name: subjectFieldName
  }),
      subjectField = _useController.field,
      subjectError = _useController.fieldState.error;

  var _useController2 = (0, _reactHookForm.useController)({
    control,
    name: messageFieldName
  }),
      messageField = _useController2.field,
      messageError = _useController2.fieldState.error;

  var _useController3 = (0, _reactHookForm.useController)({
    control,
    name: templateIdFieldName
  }),
      templateIdField = _useController3.field;

  var _useTeamMessageTempla = (0, _hooks.useTeamMessageTemplates)({
    teamId,
    queryParams: templateQueryParams
  }),
      useAllTeamTemplates = _useTeamMessageTempla.useAll,
      isTeamTemplatesPending = _useTeamMessageTempla.isPending;

  var _useUserMessageTempla = (0, _hooks.useUserMessageTemplates)({
    queryParams: templateQueryParams
  }),
      useAllUserTemplates = _useUserMessageTempla.useAll,
      isUserTemplatesPending = _useUserMessageTempla.isPending;

  var teamTemplates = useAllTeamTemplates();
  var userTemplates = useAllUserTemplates();

  var _useMemo = (0, _react.useMemo)(function () {
    var allTemplates = [].concat((0, _toConsumableArray2.default)(teamTemplates), (0, _toConsumableArray2.default)(userTemplates));
    var allowedTemplates = allTemplates.filter(function (template) {
      var _campaign$messageAllo;

      return Boolean(campaign === null || campaign === void 0 ? void 0 : (_campaign$messageAllo = campaign.messageAllowedTemplates) === null || _campaign$messageAllo === void 0 ? void 0 : _campaign$messageAllo.find(function (allowedTemplate) {
        return allowedTemplate.id === template.templateId;
      }));
    });
    var sortedTemplates = [].concat((0, _toConsumableArray2.default)(allowedTemplates), (0, _toConsumableArray2.default)(allTemplates.filter(function (template) {
      return !allowedTemplates.includes(template);
    })));
    return {
      campaignAllowedTemplates: allowedTemplates,
      templates: hasManageProspectingCampaignTemplate ? sortedTemplates : allTemplates
    };
  }, [teamTemplates, userTemplates, hasManageProspectingCampaignTemplate, campaign === null || campaign === void 0 ? void 0 : campaign.messageAllowedTemplates]),
      templates = _useMemo.templates,
      campaignAllowedTemplates = _useMemo.campaignAllowedTemplates;

  var handleSelectTemplateChange = function handleSelectTemplateChange(_, template) {
    if (template) {
      subjectField.onChange(template.subject);
      messageField.onChange(template.message);
      templateIdField.onChange(template.templateId);
    } else {
      templateIdField.onChange(null);
    }
  };

  var handleChangeSubjectWithPlaceholders = (0, _react.useCallback)(function (value) {
    subjectField.onChange(_messaging2.transformNullableStringValue.input(value));

    if (value === '') {
      trigger(subjectFieldName);
    }
  }, [subjectField, subjectFieldName, trigger]);
  var handleChangeMessageWithPlaceholders = (0, _react.useCallback)(function (value) {
    messageField.onChange(_messaging2.transformNullableStringValue.input(value));

    if (value === '') {
      trigger(messageFieldName);
    }
  }, [messageField, messageFieldName, trigger]);
  var isSaveProcessPending = isMessagingPending || isGiftsCreatePending;
  var isTemplatesFieldBlocked = isTeamTemplatesPending && isUserTemplatesPending || !(campaign !== null && campaign !== void 0 && campaign.messageOverrideEnabled) && !hasManageProspectingCampaignTemplate || isSaveProcessPending;
  var isMessagingFieldsBlocked = !(campaign !== null && campaign !== void 0 && campaign.messageEditEnabled) || isSaveProcessPending;
  var selectedTemplatedId = (0, _reactHookForm.useWatch)({
    control,
    name: templateIdFieldName
  });
  var activeTemplate = (0, _react.useMemo)(function () {
    return templates.find(function (template) {
      return template.templateId === selectedTemplatedId;
    }) || null;
  }, [templates, selectedTemplatedId]);
  var isTemplateOverridable = hasManageProspectingCampaignTemplate && campaign && !campaign.messageOverrideEnabled;
  var templateOptions = (0, _react.useMemo)(function () {
    var availableTemplates = isTemplateOverridable ? campaignAllowedTemplates : templates;

    if (!hasManageProspectingCampaignTemplate) {
      return availableTemplates;
    }

    return availableTemplates.filter(function (el) {
      var _batch$messaging2;

      return el.templateId === (batch === null || batch === void 0 ? void 0 : (_batch$messaging2 = batch.messaging) === null || _batch$messaging2 === void 0 ? void 0 : _batch$messaging2.templateId) || el.templateId === (activeTemplate === null || activeTemplate === void 0 ? void 0 : activeTemplate.templateId) || !el.deletedAt;
    });
  }, [isTemplateOverridable, campaignAllowedTemplates, templates, hasManageProspectingCampaignTemplate, batch === null || batch === void 0 ? void 0 : (_batch$messaging3 = batch.messaging) === null || _batch$messaging3 === void 0 ? void 0 : _batch$messaging3.templateId, activeTemplate === null || activeTemplate === void 0 ? void 0 : activeTemplate.templateId]);
  var groupByHandler = (0, _react.useCallback)(function (option) {
    var templateLength = templateOptions.length;

    if (isTemplateOverridable) {
      return templateLength > 1 ? "There are ".concat(templateLength, " templates available for this campaign") : "There is ".concat(templateLength, " template available for this campaign");
    }

    if (hasManageProspectingCampaignTemplate && templateOptions.includes(option)) {
      return templateLength > 1 ? "There are ".concat(templateLength, " preferred templates available for this campaign") : "There is ".concat(templateLength, " preferred template available for this campaign");
    }

    return teamTemplates.includes(option) ? 'Team templates' : 'User templates';
  }, [templateOptions, hasManageProspectingCampaignTemplate, isTemplateOverridable, teamTemplates]);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    mb: 3,
    width: 1
  }, /*#__PURE__*/_react.default.createElement(_material.Autocomplete, {
    value: activeTemplate,
    isOptionEqualToValue: function isOptionEqualToValue(option, value) {
      return option.templateId === value.templateId;
    },
    renderInput: function renderInput(params) {
      return /*#__PURE__*/_react.default.createElement(_material.TextField, (0, _extends2.default)({}, params, {
        label: "Select Template",
        variant: "outlined"
      }));
    },
    getOptionLabel: function getOptionLabel(option) {
      return option.name;
    },
    groupBy: groupByHandler,
    loading: isTeamTemplatesPending && isUserTemplatesPending,
    disabled: isTemplatesFieldBlocked,
    onChange: handleSelectTemplateChange,
    options: templateOptions,
    renderOption: function renderOption(props, option) {
      return /*#__PURE__*/_react.default.createElement("li", props, option.name, (option === null || option === void 0 ? void 0 : option.deletedAt) && hasManageProspectingCampaignTemplate && /*#__PURE__*/_react.default.createElement(_material.Typography, {
        className: "Body-Regular-Left-Error-Bold",
        color: "error.main"
      }, "\xA0- Deleted on ", (0, _moment.default)(option === null || option === void 0 ? void 0 : option.deletedAt).format(_ui.DISPLAY_DATE_FORMAT)));
    }
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mb: 2,
    width: 1
  }, /*#__PURE__*/_react.default.createElement(_material.FormControl, {
    fullWidth: true,
    error: !!(subjectError !== null && subjectError !== void 0 && subjectError.message)
  }, /*#__PURE__*/_react.default.createElement(_PlaceholdersTextField.default, {
    label: "Message Subject*",
    fullWidth: true,
    variant: "outlined",
    value: _messaging2.transformNullableStringValue.output(subjectField.value),
    disabled: isMessagingFieldsBlocked,
    onChange: handleChangeSubjectWithPlaceholders,
    onBlur: subjectField.onBlur,
    inputProps: {
      'data-testid': 'GiftingFlow.Message.Messaging.MessageSubject'
    }
  }), /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: styles.templateHelperBox
  }, !!(subjectError !== null && subjectError !== void 0 && subjectError.message) && /*#__PURE__*/_react.default.createElement(_material.FormHelperText, null, subjectError.message), /*#__PURE__*/_react.default.createElement(_ui.LimitInputCharacters, {
    sx: styles.templateHelperLimit,
    value: subjectField.value || '',
    limit: _messaging3.MESSAGING_SUBJECT_LIMIT
  })))), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mb: 2,
    width: 1
  }, /*#__PURE__*/_react.default.createElement(_material.FormControl, {
    fullWidth: true,
    error: !!(messageError !== null && messageError !== void 0 && messageError.message)
  }, /*#__PURE__*/_react.default.createElement(_PlaceholdersTextField.default, {
    label: "Message Body*",
    multiline: true,
    rows: 5,
    variant: "outlined",
    value: _messaging2.transformNullableStringValue.output(messageField.value),
    disabled: isMessagingFieldsBlocked,
    onChange: handleChangeMessageWithPlaceholders,
    onBlur: messageField.onBlur,
    inputProps: {
      'data-testid': 'GiftingFlow.Message.Messaging.MessageBody'
    }
  }), /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: styles.templateHelperBox
  }, !!(messageError !== null && messageError !== void 0 && messageError.message) && /*#__PURE__*/_react.default.createElement(_material.FormHelperText, null, messageError.message), /*#__PURE__*/_react.default.createElement(_ui.LimitInputCharacters, {
    sx: styles.templateHelperLimit,
    value: messageField.value || '',
    limit: bodyCharsLimit
  })))), !!(sendAsPersons !== null && sendAsPersons !== void 0 && sendAsPersons.length) && /*#__PURE__*/_react.default.createElement(_material.Box, {
    my: 2,
    width: 1
  }, /*#__PURE__*/_react.default.createElement(_SendAsPreview.default, {
    teamId: teamId,
    sendAsPersons: sendAsPersons
  })));
};

var _default = /*#__PURE__*/(0, _react.memo)(MessageDataController);

exports.default = _default;